// The contact details and legal links both public lead-capture forms on the landing site ask for.
// Kept out of business-case/calculator.ts so the enquiry form does not pull the whole business case
// model — and its calculator data — into the chunk that opens on a CTA click.

// Mirrors WorkEmail::COMPANY_SIZES; keep both in step.
export const COMPANY_SIZES = ["1–50", "51–250", "251–1,000", "1,000+"] as const;

export const TERMS_URL = "https://www.futurelab.my/terms-of-service";
export const PRIVACY_URL = "https://www.futurelab.my/privacy";

// Consumer and disposable inboxes. These are B2B enquiries — built for a buying team, not an
// individual. Mirrors WorkEmail::FREE_EMAIL_DOMAINS; keep both in step.
export const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com", "googlemail.com",
  "yahoo.com", "yahoo.co.uk", "yahoo.com.my", "yahoo.com.sg", "yahoo.co.id", "yahoo.com.ph", "yahoo.co.jp",
  "ymail.com", "rocketmail.com",
  "hotmail.com", "hotmail.co.uk", "hotmail.com.my", "hotmail.com.sg",
  "outlook.com", "outlook.my", "outlook.sg", "live.com", "live.com.my", "live.co.uk", "msn.com",
  "icloud.com", "me.com", "mac.com", "aol.com",
  "protonmail.com", "proton.me", "pm.me", "tutanota.com", "tuta.io", "hushmail.com", "fastmail.com",
  "zoho.com", "gmx.com", "gmx.net", "mail.com", "mail.ru", "yandex.com", "yandex.ru",
  "qq.com", "163.com", "126.com", "sina.com", "naver.com", "daum.net", "hanmail.net", "rediffmail.com",
  "tm.net.my", "streamyx.com", "jaring.my",
  "mailinator.com", "guerrillamail.com", "sharklasers.com", "yopmail.com", "trashmail.com",
  "dispostable.com", "getnada.com", "temp-mail.org", "10minutemail.com",
]);

export function isWorkEmail(email: string): boolean {
  const domain = email.trim().toLowerCase().split("@")[1];

  return Boolean(domain) && !FREE_EMAIL_DOMAINS.has(domain);
}

// Threads a resubmission to the same enquiry rather than a second lead. Nothing is persisted, so
// this is the only handle the sales inbox has. `randomUUID` needs a secure context, so the fallback
// has to produce the same 36-character shape — the server rejects anything else and mints its own,
// which would quietly lose the thread.
export function newRequestId(): string {
  if (typeof crypto?.randomUUID === "function") return crypto.randomUUID();

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    return (char === "x" ? random : (random & 0x3) | 0x8).toString(16);
  });
}
